


import { IUnidEntityAddRequest } from "../../../../model/scp/entity/request/unid-entity-add-request";
import { IUnidEntityResponse } from "../../../../model/scp/entity/response/unid-entity-response";
import HttpClient from "../../../services/http-client";

const defaultPath = 'Entity';

const listUnidEntity = async (): Promise<IUnidEntityResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/Unit`
    }).then((response) => Object.assign([] as unknown as IUnidEntityResponse, response.data));
};

const addUnidEntity = async (data: IUnidEntityAddRequest) => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/Unit`,
        data: data
    });
};


const EntityAppService = {
    listUnidEntity, addUnidEntity
};

export default EntityAppService;